// ページトップへスムーズに移動
// document.querySelectorAll('.pagetop a[href^="#"]').forEach(anchor => {
//   anchor.addEventListener('click', function (e) {
//     e.preventDefault();
//     const targetId = this.getAttribute('href');
//     const target = document.getElementById(targetId.slice(1));
//     if (!target) return;

//     window.scrollTo({
//       top: target.offsetTop,
//       behavior: 'smooth'
//     });
//   });
// });


//シンプルアコーディオン
document.addEventListener('DOMContentLoaded', () => {
  const questions = document.querySelectorAll('.accordion-headline');

  questions.forEach((btn) => {
    const content = btn.nextElementSibling;

    btn.addEventListener('click', () => {
      // 他を閉じる
      questions.forEach((otherBtn) => {
        if (otherBtn !== btn) {
          otherBtn.classList.remove('is-open');
          otherBtn.nextElementSibling.style.height = '0';
        }
      });

      // 自分の開閉
      const isOpen = btn.classList.toggle('is-open');
      if (isOpen) {
        content.style.height = content.scrollHeight + 'px';
      } else {
        content.style.height = '0';
      }
    });
  });
});

//汎用アコーディオン（親と子のレイアウト自由度高め）
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion-layout').forEach(currentWrapper => {
    const currentToggle = currentWrapper.querySelector('.accordion-toggle');
    const currentPanel = currentWrapper.querySelector('.accordion-panel');

    currentToggle.addEventListener('click', e => {
      e.preventDefault();

      // すでに開いているか確認
      const isOpen = currentPanel.classList.contains('is-open-panel');

      // 全てのアコーディオンを閉じる
      document.querySelectorAll('.accordion-layout').forEach(wrapper => {
        const panel = wrapper.querySelector('.accordion-panel');
        const toggle = wrapper.querySelector('.accordion-toggle');
        panel.style.height = '0';
        panel.classList.remove('is-open-panel');
        toggle.classList.remove('is-open-panel');
      });

      // 今クリックしたのが閉じていたら開く
      if (!isOpen) {
        currentPanel.classList.add('is-open-panel');
        currentToggle.classList.add('is-open-panel');
        currentPanel.style.height = 'auto';
        const height = currentPanel.scrollHeight + 'px';
        currentPanel.style.height = '0';
        requestAnimationFrame(() => {
          currentPanel.style.height = height;
        });
      }
    });

    // transition後に height を auto に
    currentPanel.addEventListener('transitionend', () => {
      if (currentPanel.classList.contains('is-open-panel')) {
        currentPanel.style.height = 'auto';
      }
    });
  });
});

// sitemap SP
document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.click-open');
  toggles.forEach(toggle => {
    const tree = toggle.closest('.navi_sitemap--tree');
    const content = tree?.querySelector('.navi_sitemap--second');

    toggle.addEventListener('click', e => {
      e.preventDefault();
      if (content.classList.contains('is-open')) {
        // 閉じる時は現在の高さをセットしてから 0 にする
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0px';
          content.classList.remove('is-open');
          toggle.classList.remove('is-open');
        });
      } else {
        // 開くときは一旦heightを0にしてから実サイズへ
        content.classList.add('is-open');
        toggle.classList.add('is-open');
        content.style.height = 'auto';
        const height = content.scrollHeight + 'px';
        content.style.height = '0px';
        requestAnimationFrame(() => {
          content.style.height = height;
        });
      }
    });

    // アニメーション終了後に height を auto に戻す
    content.addEventListener('transitionend', () => {
      if (content.classList.contains('is-open')) {
        content.style.height = 'auto';
      }
    });
  });
});


//SP Menu
document.addEventListener('DOMContentLoaded', () => {
  const fullNav = document.getElementById('fullNav');

  // 開閉ボタン共通でイベント設定
  document.querySelectorAll('.nav-toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = fullNav.classList.contains('is-active');
      fullNav.classList.toggle('is-active', !isOpen);
      document.getElementById('menuBtn').classList.toggle('is-active', !isOpen);
    });
  });
});